import { Link, useParams } from 'react-router-dom'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { ContentCard } from '../components/ContentCard'
import { YouTubeEmbed } from '../components/YouTubeEmbed'
import { ARTICLES, getArticleBySlug } from '../data/articles'
import { getContentById } from '../data/content'
import { useSeo } from '../hooks/useSeo'

export function SpiritualPage() {
  useSeo({
    title: 'ஆன்மீக தகவல்கள்',
    description: 'பண்டிகைகள், பாரம்பரியம் மற்றும் ஆன்மீக அறிவுக் கட்டுரைகள்.',
    path: '/spiritual',
  })

  return (
    <div className="page-hero">
      <div className="container section">
        <Breadcrumbs items={[{ label: 'முகப்பு', to: '/' }, { label: 'ஆன்மீக தகவல்கள்' }]} />
        <div className="section-header">
          <h1>ஆன்மீக தகவல்கள்</h1>
          <p>பண்டிகை முக்கியத்துவம், வரலாறு மற்றும் பக்தி வழிகாட்டுதல் — எளிய தமிழில்.</p>
        </div>
        <div className="card-grid card-grid--3">
          {ARTICLES.map((article) => (
            <Link key={article.id} to={`/spiritual/${article.slug}`} className="content-card">
              <span className="content-card__meta">கட்டுரை</span>
              <h3>{article.titleTa}</h3>
              <span className="content-card__en">{article.titleEn}</span>
              <p>{article.excerptTa}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export function ArticleDetailPage() {
  const { slug = '' } = useParams()
  const article = getArticleBySlug(slug)
  const related = (article?.relatedContentIds ?? []).map(getContentById).filter(Boolean)

  useSeo({
    title: article ? article.titleTa : 'கட்டுரை',
    description: article?.seoDescription,
    path: `/spiritual/${slug}`,
  })

  if (!article) {
    return (
      <div className="container section">
        <div className="empty-state">
          <h1>கட்டுரை கிடைக்கவில்லை</h1>
          <Link className="btn btn--primary" to="/spiritual">
            பட்டியலுக்குச் செல்லவும்
          </Link>
        </div>
      </div>
    )
  }

  return (
    <article className="section">
      <div className="container prose">
        <Breadcrumbs
          items={[
            { label: 'முகப்பு', to: '/' },
            { label: 'ஆன்மீகம்', to: '/spiritual' },
            { label: article.titleTa },
          ]}
        />
        <p className="eyebrow">{article.titleEn}</p>
        <h1>{article.titleTa}</h1>
        <p>{article.excerptTa}</p>
        {article.youtubeVideoId && (
          <div style={{ margin: '1.25rem 0 1.75rem' }}>
            <YouTubeEmbed videoId={article.youtubeVideoId} title={article.titleTa} />
          </div>
        )}
        <div className="article-body">
          {article.bodyTa.split('\n\n').map((block, i) => {
            if (block.startsWith('**') && block.includes('**\n') === false && block.endsWith('**') === false) {
              const titleMatch = block.match(/^\*\*(.+?)\*\*\n?([\s\S]*)$/)
              if (titleMatch) {
                return (
                  <div key={i}>
                    <h2>{titleMatch[1]}</h2>
                    {titleMatch[2] && <p>{titleMatch[2]}</p>}
                  </div>
                )
              }
            }
            if (block.startsWith('**')) {
              const lines = block.split('\n')
              const heading = lines[0].replace(/\*\*/g, '')
              const rest = lines.slice(1).join('\n')
              return (
                <div key={i}>
                  <h2>{heading}</h2>
                  {rest && <p>{rest}</p>}
                </div>
              )
            }
            return <p key={i}>{block}</p>
          })}
        </div>
        <p className="disclaimer-inline">
          பழக்க வழக்கங்கள் பிராந்தியம் மற்றும் குடும்பத்திற்கு ஏற்ப மாறலாம். ஆரோக்கியம், நிதி அல்லது வாழ்க்கை
          முடிவுகள் உத்தரவாதம் அளிக்கப்படுவதில்லை.
        </p>
        {related.length > 0 && (
          <section style={{ marginTop: '2rem' }}>
            <h2>தொடர்புடைய உள்ளடக்கம்</h2>
            <div className="card-grid card-grid--3">
              {related.map((r) => r && <ContentCard key={r.id} item={r} />)}
            </div>
          </section>
        )}
      </div>
    </article>
  )
}
